import React from 'react';
import { MenuItem as MuiMenuItem } from '@mui/material';
import { useHistory } from 'react-router-dom';
import {
  MenuTriggerButton,
  SimpleMenu,
} from '../../../../components/Menus/SimpleMenu';
import { type SubmissionTableRow } from '../../../../api/submissions/submissions.api.types';
import { withShowable } from '../../../_global/lib/withShowable';
import {
  RequestQuoteSteps,
  UNKNOWN_PRODUCT,
} from '../../../agencies/quotes/PrimeX/constants';
import { usePersona } from '../../../../components/hooks/usePersona';
import { useCanPerformActionOnSubmission } from '../../utils';
import { useSubmissionReadOnly } from '../../hooks/useSubmissionReadOnly';

const MenuItem = withShowable(MuiMenuItem);

type AgencySubmissionsOptionsProps = {
  data: SubmissionTableRow;
};

export const AgencySubmissionsOptions = ({
  data,
}: AgencySubmissionsOptionsProps) => {
  const persona = usePersona();
  const history = useHistory();

  const canPerformAction = useCanPerformActionOnSubmission(data);
  const { locked } = useSubmissionReadOnly(data);

  const createQuoteRedirect = () => {
    history.push(
      `${persona.basePath}/submissions/quotes/${UNKNOWN_PRODUCT}/${data.id}/requestQuote/${RequestQuoteSteps.VERIFY_SUBMISSION_INFO}`
    );
  };

  if (!canPerformAction || locked) {
    return null;
  }

  return (
    <SimpleMenu
      id="agency-submissions-options"
      anchor={<MenuTriggerButton />}
      minWidth="19rem"
    >
      <MenuItem onClick={createQuoteRedirect}>Request Quote</MenuItem>
    </SimpleMenu>
  );
};
